import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { UseMutationResult } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mySettingsQueryOptions } from '../../close-the-loop';
import { saveLanguage } from '../api/language.api';
import type { LanguageChoice } from '../../../i18n/languages';
import { accountKeys, accountMutationKeys } from '../utils/queryOptions';

export const useSaveLanguage = (): UseMutationResult<void, Error, LanguageChoice> => {
  const queryClient = useQueryClient();
  const { i18n } = useTranslation();
  return useMutation<void, Error, LanguageChoice>({
    mutationKey: accountMutationKeys.language(),
    mutationFn: (language) => saveLanguage(language, undefined),
    onSuccess: async (_saved, language) => {
      await i18n.changeLanguage(language);
    },
    onSettled: () =>
      Promise.all([
        queryClient.invalidateQueries({ queryKey: accountKeys.profile() }),
        queryClient.invalidateQueries({ queryKey: mySettingsQueryOptions().queryKey }),
      ]),
  });
};
